export default {
    services: [],
    servicesById: {},
    clientServicesByClientId: {},
    progress: {
        getAllServices: false,
        createService: false,
        updateService: false,
        deleteService: false,
        getClientServicesByClientId: false,
        addServiceToClient: false,
        updateClientService: {}
    },
    errorMessagesByFields: {
        createService: {},
        updateService: {},
    },
    serviceFormContexts: {
        create: {

        },
        update: {

        }
    }
}